module.exports = __webpack_public_path__ + "static/mind_sliver-8dfda81741d29cfb052bfb3152908c6c.png";